<button type="button"
        class="column-insert-button"
        draggable="true"
        appBringozIdGenerator="table_column_insert"
        [attr.aria-label]="'Add Column' | translate"
        [title]="'Add Column' | translate"
        (dragstart)="preventDrag($event)"
        (click)="openPicker($event)">
</button>
